var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M0.31854 10.9799L10.1195 20.1942C10.5495 20.5976 11.2463 20.5976 11.6775 20.1942C12.1075 19.7908 12.1075 19.1355 11.6775 18.7321L2.65391 10.2489L11.6764 1.76573C12.1064 1.3623 12.1064 0.707023 11.6764 0.302572C11.2463 -0.100857 10.5485 -0.100857 10.1184 0.302572L0.317454 9.51677C-0.105999 9.91603 -0.105999 10.5816 0.31854 10.9799Z",
    fill: "#29185E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeft);
export default __webpack_public_path__ + "static/media/arr-left.734198dd44611f26f45c0159efe5ac13.svg";
export { ForwardRef as ReactComponent };